import { FLIPBOOK_URL, openFlipbook } from "../lib/links";

// The artist's flipbook, opened in place inside the gallery (the href stays for a long-press / no-JS)
export function FlipbookLink({ testid, className = "", children = "The Flipbook" }) {
  return (
    <a
      href={FLIPBOOK_URL}
      data-testid={testid}
      className={className}
      onClick={(e) => {
        e.preventDefault();
        openFlipbook(testid);
      }}
    >
      {children}
    </a>
  );
}
